@if ((pointsEarnedRedeemedService.series$ | async); as series) { @if
(series.length > 0 && series[0].data.length > 0) {
<div id="points-earned-redeemed-chart" data-cy="points-earned-redeemed-chart">
  <apx-chart
    [series]="series"
    [chart]="settings.chart"
    [xaxis]="settings.xAxis"
    [stroke]="settings.stroke"
    [tooltip]="settings.toolTip"
    [dataLabels]="settings.dataLabels"
    [legend]="settings.legend"
    [markers]="settings.markers"
    [grid]="settings.grid"
    [yaxis]="settings.yAxis"
    [colors]="settings.colors"
  ></apx-chart>
</div>
} @if (pointsEarnedRedeemedService.loading$ | async) {
<mat-spinner></mat-spinner>
} }
